export default class ElevatorFilter {
  adsCategory = [];
  buildingTypes = [];
  regions = [];


  constructor() {
  }

}